import React from 'react';
import EditableField from './EditableField';
import EditableDropdown from './EditableDropdown';
import LoadableIcon from './LoadableIcon';
import ButtonDelete from './ButtonDelete';
import ButtonAction from './ButtonAction';
import EntityForm from './EntityForm';
import { ButtonGroup } from 'reactstrap';
import { CREATOR_TYPES, CREATOR_FIELDS } from '../constants/Fixtures';
import * as warnings from '../constants/ValidationWarnings';

export default class Creator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      loading: false,
    };
  }

  clickCreatorNameHandle = () => {
    this.setState({ editing: true });
  }

  clearEdit = () => {
    this.setState({ editing: false });
  }

  // no validation atm
  validateCreatorName(name) {
    return /^.+$/.test(name);
  }

  nameGroup = () => [
    {
      category: 'first_name',
      content: this.props.first_name,
      validation: this.validateCreatorName,
      editTitle: "Enter the creator's first name",
    },
    {
      category: 'middle_name',
      content: this.props.middle_name,
      validation: () => true,
      editTitle: "Enter the creator's middle name",
    },
    {
      category: 'last_name',
      content: this.props.last_name,
      validation: this.validateCreatorName,
      editTitle: "Enter the creator's last name",
    },
    {
      category: 'suffix',
      content: this.props.suffix,
      validation: () => true,
      editTitle: "Enter the creator's suffix or honorific",
    },
  ]

  destroy = () => {
    this.setState({
      loading: true,
    });
    this.props.destroy(this.props.id);
  }

  updateCreator = (attributes) => {
    // supply a default for category
    if (attributes.category === undefined) {
      attributes.category = 'author';
    }
    this.props.update(this.props.id, attributes);
    this.setState({ editing: false });
  }

  render(){
    const convElements = this.nameGroup().reduce((acc, item) => {
      let {category, content} = item;
      return {...acc, [category]: content};
    }, {category: this.props.type});

    if (this.state.editing) {
      return (
        <EntityForm
          key={`${this.props.title || 'creator'}-form-${this.state.formIndex}`}
          fields={CREATOR_FIELDS}
          action={this.updateCreator}
          formElements={convElements}
        />
      );
    }
    else{
      return(
        <tr>
          <td
              className="item-name creator-field"
            >
              {CREATOR_TYPES.find((i) => i.value == this.props.type).label}
          </td>
          {this.nameGroup().map(item =>
            (<td
              className="item-name creator-field"
              key={item.category}
            >
              {item.content ? item.content : <span className="empty-field">[empty]</span>}
            </td>),
          )}
          <td className="section-table-remove">
            <ButtonGroup size='sm'>
              <ButtonAction
                size='sm'
                title='Edit creator'
                id={`creator-${this.props.id}`}
                className="btn-edit"
                action={this.clickCreatorNameHandle}
                type="button"
                icon="fa-pencil"
                color="secondary"
              />
              <ButtonDelete
                size='sm'
                title='Remove creator'
                id={`creator-${this.props.id}`}
                action={this.destroy}
                noConfirm
              />
            </ButtonGroup>
          </td>
        </tr>
      );
    }
  }
}
